import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import {iconsArr2} from './Icons'
import { withRouter } from 'react-router'
import { compose } from 'react-apollo'
import withTranslations from 'containers/withTranslations'
import LocalizedString from 'ui/components/generic/LocalizedString'


class Advantages extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        iconsArray: this.props.icons.map((item, index) => item.advantage_icon)
    }

    componentDidMount = () => {
        console.log(this.state.iconsArray)
        this.orderedArray()
    }

    //Creates a new array that is a result of a comparison of array that comes from wordpress and the one received from Icons.js
    //New array contains only neccessary icons in a correct order
    orderedArray = () => {
        let newArray = iconsArr2.sort((a, b) => this.state.iconsArray.indexOf(a.name) - this.state.iconsArray.indexOf(b.name));
        return newArray
    }
    render() {
        const {
            icons
        } = this.props

        const { iconsArray } = this.state

        return (
           <Wrapper>
            {/* Loops through a newly created array. Makes visible only those icons that are included in the array */}
            {this.orderedArray().map((a) => 
            <Icon visible={iconsArray.includes(a.name) ? true : false} key={a.id}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" dangerouslySetInnerHTML={{__html: a.svg}}></svg>
                    <Description>{<LocalizedString group="advantageIcons" string={a.field}/>}</Description>
            </Icon>
            )}
            </Wrapper>
        )
    }
}

export default compose (
    withRouter,
    withTranslations()
)(Advantages)

const Wrapper = styled.section`
display: flex;
flex-wrap: wrap;
margin-left: -8px;
gap: 32px;
justify-content: space-between;
${media.lg`
justify-content: left;
`}

${media.md`
max-width: 80%;
`}
`

const Icon = styled.div`
display: ${props => props.visible === true ? "block" : "none"};
width: 124px;
`
const Description = styled.div`
text-align: center;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductPage/Advantages.js